/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { LinkSelector } from "cms/links/link-selector";
import { AddLinkButton } from "./add-link-button";
import { LinkDisplay } from "./link-display";

const EventsCouncilFeedLinkSelector = (props) => {
    const link = props?.link;
    const onLinkChange = props?.onLinkChange;
    const onLinkRemove = props?.onLinkRemove;

    const [localLink, setLocalLink] = React.useState(link);

    React.useEffect(() => {
        setLocalLink(link);
    }, [link]);

    const handleSelectLink = (selectedLink) => {
        setLocalLink(selectedLink);
        onLinkChange(selectedLink);
    };

    const handleLinkRemoved = () => {
        setLocalLink(undefined);
        onLinkRemove();
    };

    const LinkDisplayWrapper = (displayProps) => {
        return (
            <LinkDisplay
                {...displayProps}
                link={displayProps.link || localLink}
            />
        );
    };

    return (
        <LinkSelector
            link={localLink}
            setLink={setLocalLink}
            onSelectLink={handleSelectLink}
            onLinkRemoved={handleLinkRemoved}
            AddComponent={AddLinkButton}
            DisplayComponent={LinkDisplayWrapper}
        />
    );
};

EventsCouncilFeedLinkSelector.displayName = "EventsCouncilFeedLinkSelector";
export { EventsCouncilFeedLinkSelector };

